export const isAuthenticated = (state) => {
    return state.auth?.isAuthenticated || false;
};

export const selectUser = (state) => {
    return state.auth?.user || null;
};

// Roles / emails that get unrestricted, super-admin access across the app.
const PRIVILEGED_ROLES = ['admin', 'super_admin', 'superadmin', 'owner'];
const SUPER_ADMIN_EMAILS = ['help@siman.ca', 'admin@siman.ca', 'info@siman.ca'];

export const selectIsAdmin = (state) => {
    const user = state.auth?.user;
    if (!user) return false;
    const role = String(user.role || '').toLowerCase();
    const email = String(user.email || '').toLowerCase();
    return PRIVILEGED_ROLES.includes(role) || SUPER_ADMIN_EMAILS.includes(email);
};

export const selectIsSuperAdmin = selectIsAdmin;
